import { DailyOccurrence } from '../DailyOccurrence';

export const WeeklyOccurrence = ({ events = [], source = '', showAssigner = false }) => {
  // Map events to days of week
  const dailyMappedEvents = {
    Sunday: [],
    Monday: [],
    Tuesday: [],
    Wednesday: [],
    Thursday: [],
    Friday: [],
    Saturday: [],
  };

  events.forEach((event) => {
    const dayOfWeek = event.start.toLocaleDateString('en-US', { weekday: 'long' });
    if (dailyMappedEvents[dayOfWeek]) {
      dailyMappedEvents[dayOfWeek].push(event);
    }
  });

  return (
    <div
      className="d-flex flex-row flex-wrap gap-3 justify-content-center"
      // style={{ display: 'flex', flexDirection: 'row', flexWrap: 'wrap', gap: 16 }}
    >
      {Object.entries(dailyMappedEvents).map(([day, dayEvents]) => (
        <div key={day} style={{ minWidth: '20%', flex: '1 0 20%', boxSizing: 'border-box' }}>
          <h4 className="text-center">{day}</h4>
          <DailyOccurrence events={dayEvents} source={source} showAssigner={showAssigner} />
        </div>
      ))}
    </div>
  );
};
